import React from 'react'
import styled from 'styled-components'
import { Text, PillButton } from '@energytoolbase/components'
import { isDevEnv } from '../../utils/env'

const ErrorDiv = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export interface ErrorProps {
  readonly message: string
  readonly showSupportMessage?: boolean
  readonly error?: unknown
  readonly retryButtonText?: string
  readonly onRetry?: () => void
}

export function Error({
  error,
  showSupportMessage = true,
  retryButtonText = 'Refresh',
  message,
  onRetry
}: ErrorProps): JSX.Element {
  const errorInstance = error as Error

  return (
    <ErrorDiv>
      <Text text={message} />
      {showSupportMessage && (
        <Text text='Please try again later, if this problem continues, contact our support at 1-866-303-7786' />
      )}
      {errorInstance && isDevEnv() && (
        <Text
          style={{ color: 'red' }}
          text={`Error message: ${errorInstance.message}`}
        />
      )}
      {onRetry && (
        <PillButton
          buttonClass='btn btn-primary'
          text={retryButtonText}
          onClick={onRetry}
        />
      )}
    </ErrorDiv>
  )
}
